var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.04 14.5261C17.62 14.9361 17.38 15.5261 17.44 16.1561C17.53 17.2361 18.52 18.0261 19.6 18.0261H21.5V19.2161C21.5 21.2861 19.81 22.9761 17.74 22.9761H6.26C4.19 22.9761 2.5 21.2861 2.5 19.2161V12.4861C2.5 10.4161 4.19 8.72607 6.26 8.72607H17.74C19.81 8.72607 21.5 10.4161 21.5 12.4861V13.9261H19.48C18.92 13.9261 18.41 14.1461 18.04 14.5261Z",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.3859V8.81593C2.5 7.62593 3.23 6.56589 4.34 6.14589L12.28 3.14589C13.52 2.67589 14.85 3.59592 14.85 4.92592V8.72591",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5588 14.9462V17.0063C22.5588 17.5563 22.1188 18.0062 21.5588 18.0262H19.5988C18.5188 18.0262 17.5288 17.2363 17.4388 16.1562C17.3788 15.5263 17.6188 14.9362 18.0388 14.5262C18.4088 14.1462 18.9188 13.9263 19.4788 13.9263H21.5588C22.1188 13.9463 22.5588 14.3962 22.5588 14.9462Z",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.9761H14",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.390e289927f0e35a2487f4dc141931b6.svg";
export { ForwardRef as ReactComponent };